import clsx from 'clsx';
import React, { useState } from 'react';

import styles from './styles.module.css';

const GdprOptIn = () => {
  const [optIn, setOptIn] = useState<boolean>(true);

  return (
    <div className={styles.marketingOptInContainer}>
      <label className={styles.marketingOptIn}>
        <span className={styles.formControlText}>
          Get Breaking News, Relevant Stories, and Special Event &amp; Editorial Invites
        </span>
        <input
          type="checkbox"
          value="1"
          name="user[opt_in]"
          className={clsx(styles.optInCheckbox, 'opt-in')}
          onChange={() => setOptIn(!optIn)}
          checked={optIn}
        />
        <span className={clsx(styles.checkboxFill, { [styles.checkboxChecked]: optIn })}>
          <span className={clsx(styles.innerCheckbox, { [styles.filled]: optIn })}></span>
        </span>
      </label>
    </div>
  );
};

export default GdprOptIn;
